import {Col, Row, Table} from "react-bootstrap";
import React from "react";
import {useSpecificationQuery} from "../../../../../hooks/useSpecificationQuery";
import {SpecificationModel} from "../../../../../models/domain/specificationModel";

export const Specifications = () => {
    const {
        model: {hasSpecifications, specifications: specificationColumns},
    } = useSpecificationQuery();

    // If there are no specifications, don't render anything
    if (!hasSpecifications) return <></>;

    const renderTable = (specifications: SpecificationModel[]) => (
        <Table striped className="">
            <tbody>
            {specifications.map((specification: SpecificationModel, index) => (
                <tr key={index}>
                    <th>{specification.types.join(specification.delimiter)}</th>
                    <td className="text-end">{specification.values.join(specification.delimiter)}</td>
                </tr>
            ))}
            </tbody>
        </Table>
    );

    const halfLength = Math.ceil(specificationColumns[0].length / 2);
    const firstHalf = specificationColumns.flatMap(column => column.slice(0, halfLength));
    const secondHalf = specificationColumns.flatMap(column => column.slice(halfLength));

    return (
        <div className="product-specifications">
            <Row>
                <Col md={6}>
                    {renderTable(firstHalf)}
                </Col>
                <Col md={6}>
                    {renderTable(secondHalf)}
                </Col>
            </Row>
        </div>
    );
};